import * as dates from "../../../reducers/changeTimePeriod";

import { IDayCell_Month, IDayCellSlot_Month } from "../../../classes/dayCell_Month";
import { IEventViewProps } from "../EventView";

export function initialiseDaysCellsForThisMonth(monthStartDate: Date, monthEndDate: Date): IDayCell_Month[] {
  // Pre-populate array of dayCells for days of month with date and day number of week for each dayCell.

  const totalDaysInMonth = dates.getDaysBetweenDates(monthStartDate, monthEndDate);

  const dayCells: IDayCell_Month[] = new Array(totalDaysInMonth);

  let dayCellDate = monthStartDate;
  let dayNumberOfWeek = 0;
  for (let cellNumber = 0; cellNumber < totalDaysInMonth + 1; cellNumber++) {
    // Set default data for this day's dayCell:
    const thisDayCell: IDayCell_Month = {
      cellNumber,
      date: dayCellDate,
      dayNumberOfWeek,
      slots: [],
      totalNumberEvents: 0,
    };
    dayCells[cellNumber] = thisDayCell;

    // Advance to the next day:
    dayCellDate = dates.addDays(dayCellDate, 1);
    dayNumberOfWeek++;
    if (dayNumberOfWeek > 6) { dayNumberOfWeek = 0; }
  }

  return dayCells;
}

function getMaxExtensionOfEventWithinWeek(dateStart: Date, dateEnd: Date, dayNumberOfWeek: number): number {
  const daysUntilEndOfEventFromThisDate = dates.getDaysBetweenDates(dateStart, dateEnd);
  const daysLeftInWeek = 6 - dayNumberOfWeek;
  const maxExtensionWithinWeek = Math.min(daysLeftInWeek, daysUntilEndOfEventFromThisDate);
  return maxExtensionWithinWeek;
}

function getFirstAvailableDaySlotNumber(slots: IDayCellSlot_Month[]): number {
  let firstAvailableDaySlotNumber = null;

  if (!slots[0]) {
    firstAvailableDaySlotNumber = 0;
  } else if (!slots[1]) {
    firstAvailableDaySlotNumber = 1;
  } else if (!slots[2]) {
    firstAvailableDaySlotNumber = 2;
  } else {
    firstAvailableDaySlotNumber = slots.length;
  }
  return firstAvailableDaySlotNumber;
}

export function transformListOfEventsIntoArrayOfDayCellsForMonth(props: IEventViewProps): IDayCell_Month[] {

  // Create an array of dayCells (one per day of displayed month), and add an empty dayCell to each cell in array.
  const dayCells: IDayCell_Month[] = initialiseDaysCellsForThisMonth(props.localFromDate, props.localToDate);

  // Loop through the events and assign them to the dayCells:
  for (const event of props.events) {

    // If the event starts before the displayed month, have to set start date to first day of month.
    let firstVisibleDateOfEvent = event.localStartDate;
    if (dates.isBefore(firstVisibleDateOfEvent, props.localFromDate) && dates.isAfter(event.localEndDate, props.localFromDate)) {
      firstVisibleDateOfEvent = props.localFromDate;
    }

    // Find the dayCell this event should begin in.
    const eventsDayCell = dayCells.filter((thisDayCell) => dates.isSameDay(thisDayCell.date, firstVisibleDateOfEvent))[0];

    if (eventsDayCell) {
      // Create the new dayCellSlot object.
      const maxExtensionWithinWeek = getMaxExtensionOfEventWithinWeek(firstVisibleDateOfEvent, event.localEndDate, eventsDayCell.dayNumberOfWeek);
      const firstAvailableDaySlotNumber = getFirstAvailableDaySlotNumber(eventsDayCell.slots);

      const dayCellSlot: IDayCellSlot_Month = {
        event,
        isOccupiedAlready: false,
        maxExtensionWithinWeek,
        slotNumber: firstAvailableDaySlotNumber,
      };

      // Add dayCellSlot to the topmost upoccupied slot in the dayCell.
      eventsDayCell.slots[firstAvailableDaySlotNumber] = dayCellSlot;
      eventsDayCell.totalNumberEvents++;

      // Extend event forward into future days that it should occupy.
      const eventDurationInDays = dates.getDaysBetweenDates(firstVisibleDateOfEvent, event.localEndDate);
      const daysUntilEndOfDisplayedMonth = dates.getDaysBetweenDates(firstVisibleDateOfEvent, props.localToDate);
      const daysToExtendForward = Math.min(eventDurationInDays, daysUntilEndOfDisplayedMonth);
      if (eventDurationInDays > 0) {
        for (let extension = 1; extension <= daysToExtendForward; extension++) {

          const extensionDayCell = dayCells[eventsDayCell.cellNumber + extension];
          if (extensionDayCell) {
            if (extensionDayCell.cellNumber !== 0 && extensionDayCell.cellNumber % 7 === 0) {
              // Extension of event falls on the first day of a new week, so add the event to that day's slots so it will be rendered in the new week.
              const maxExtensionWithinSubsequentWeek = getMaxExtensionOfEventWithinWeek(extensionDayCell.date, dates.addSeconds(event.localEndDate, 1), extensionDayCell.dayNumberOfWeek);

              const subsequentWeekDayCellSlot: IDayCellSlot_Month = {
                event,
                isOccupiedAlready: false,
                maxExtensionWithinWeek: maxExtensionWithinSubsequentWeek,
                slotNumber: firstAvailableDaySlotNumber,
              };

              extensionDayCell.slots[firstAvailableDaySlotNumber] = subsequentWeekDayCellSlot;
              extensionDayCell.totalNumberEvents++;

            } else {
              // Not the first day of a week, so add the event as an 'isOccupied' slot.
              const extendedEventDaySlot = Object.assign({}, dayCellSlot);
              extendedEventDaySlot.isOccupiedAlready = true;
              extensionDayCell.slots[firstAvailableDaySlotNumber] = extendedEventDaySlot;
              extensionDayCell.totalNumberEvents++;
            }
          }
        }

      }
    } else {
      // console.log(event.name);
    }
  }

  return dayCells;
}
